import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { RefreshCw, AlertTriangle } from "lucide-react";
import { getSubjectDisplayName } from "./utils";

export function RenewSubjectModal({
  open,
  onOpenChange,
  selectedSubject,
  renewDuration,
  setRenewDuration,
  onConfirm,
  loading
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Renew Subject</DialogTitle>
          <DialogDescription>
            Choose a renewal duration for {selectedSubject?.display_name || getSubjectDisplayName(selectedSubject?.subject)}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          {/* Duration Selection */}
          <div>
            <label className="text-sm font-medium text-gray-700 mb-2 block">
              Renewal Duration
            </label>
            <Select value={renewDuration} onValueChange={setRenewDuration}>
              <SelectTrigger className="w-full" data-testid="renew-duration-select">
                <SelectValue placeholder="Select duration" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="monthly">
                  <span>Monthly</span>
                </SelectItem>
                <SelectItem value="3_months">
                  <div className="flex items-center gap-2">
                    <span>3 Months</span>
                    <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded">5% off</span>
                  </div>
                </SelectItem>
                <SelectItem value="6_months">
                  <div className="flex items-center gap-2">
                    <span>6 Months</span>
                    <span className="text-xs bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded">10% off</span>
                  </div>
                </SelectItem>
              </SelectContent>
            </Select>
          </div>
          
          {/* Current Status Info */}
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm">
            <p className="text-amber-800">
              <AlertTriangle className="h-4 w-4 inline mr-1" />
              {selectedSubject?.status === "expired" 
                ? "This subject has expired. Renewing will reactivate it immediately."
                : "This subject is due for renewal soon."}
            </p>
          </div>
        </div>
        
        <div className="flex gap-3">
          <Button
            variant="outline"
            className="flex-1"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            className="flex-1 bg-emerald-600 hover:bg-emerald-700"
            onClick={onConfirm}
            disabled={loading}
            data-testid="confirm-renew-subject-btn"
          >
            {loading ? (
              <RefreshCw className="h-4 w-4 animate-spin mr-2" />
            ) : (
              <RefreshCw className="h-4 w-4 mr-2" />
            )}
            Renew Subject
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default RenewSubjectModal;
